var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowsWhite = function SvgShowsWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.619 0H4.944a.857.857 0 0 0 0 1.713h9.817v9.816a.857.857 0 0 0 1.714 0V.856a.856.856 0 0 0-.856-.857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.017 4.599H1.332a.857.857 0 0 0-.857.856v9.688c0 .473.384.857.857.857h9.685a.857.857 0 0 0 .857-.857V5.455a.855.855 0 0 0-.857-.856"
  })));
};
export default SvgShowsWhite;